module.exports = {
    "bigCardContent": "mcb58e8535_bigCardContent"
};